import {
  AppShell,
  AppShellMobileNavigationTrigger,
  AssetWatchLogo,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  Sidebar,
  SidebarItem,
  Switch,
  TopBar,
  TopBarActions,
  TopBarContent,
  TopBarLeading,
  useTheme,
} from "@assetwatch/ui";
import {
  createFileRoute,
  Link,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { useEffect } from "react";
import { setCmeRouteSentryContext } from "../lib/sentry";

function CmeThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <Switch
      aria-label="Use dark mode"
      checked={theme === "dark"}
      onCheckedChange={toggleTheme}
    />
  );
}

function CmeLayout() {
  const pathname = useRouterState({
    select: (state) =>
      state.resolvedLocation?.pathname ?? state.location.pathname,
  });

  useEffect(() => {
    setCmeRouteSentryContext(pathname);
  }, [pathname]);

  return (
    <AppShell>
      <TopBar>
        <TopBarLeading>
          <AppShellMobileNavigationTrigger />
          <span className="max-[599px]:hidden">
            <AssetWatchLogo aria-label="AssetWatch" />
          </span>
        </TopBarLeading>
        <TopBarContent>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbPage>Home</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </TopBarContent>
        <TopBarActions>
          <CmeThemeToggle />
        </TopBarActions>
      </TopBar>
      <Sidebar mobileHeaderLeading={<AssetWatchLogo aria-label="AssetWatch" />}>
        <SidebarItem
          itemId="home"
          label="Home"
          leading={{ type: "icon", name: "home" }}
          render={<Link to="/" />}
          selected={pathname === "/"}
        />
      </Sidebar>
      <Outlet />
    </AppShell>
  );
}

export const Route = createFileRoute("/_app")({
  component: CmeLayout,
});
